<template>
    <section class="app-main">
        <div class="app-mainCon">
            <transition name="fade-transform" mode="out-in">
                <div class="app-mainCon-content">
                    <keep-alive key="keepalive">
                        <router-view v-if="!$route.meta.noKeepAlive" :key="key"></router-view>
                    </keep-alive>
                    <router-view v-if="$route.meta.noKeepAlive" ></router-view>
                </div>
            </transition>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AppMain',
    computed: {
        key() {
            return this.$route.fullPath
        }
    }
}
</script>

<style  scoped>
.app-main {
    height: calc(100vh - 50px);
    box-sizing:border-box;
    margin: 0 auto;
    padding: 20px 20px 0;
    position: relative;
    overflow: hidden;
}
.app-mainCon{
    height:100%;
}

.app-mainCon-content{
    height: 100%;
}
/* @media screen and (max-width:1290px) {
    .app-main {
            height: calc(100vh -160px);  
    } 
} */
</style>



// WEBPACK FOOTER //
// src/pages/layout/comps/appMain.vue